import { Component } from "react";
import { connect } from "react-redux";
import actionCreators from "../../../../store/HowTo/Category/Articles/actionCreators";
import { default as mainMenuActionCreators } from "../../../../store/MainMenu/actionCreators";
import { default as froalaActionCreators } from "../../../../store/Froala/actionCreators";
import { default as categoryActionCreators } from "../../../../store/HowTo/Category/actionCreators";
import Form from "./Form";
import currentFormTypes from "../../../../common/components/CurrentFormTypes";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import formsCss from "../../../../common/styles/forms.css";
import { MainTitle } from "../../../../common/components/MainTitle";

class HowToArticlesEditContainer extends Component {
    componentDidMount() {
        const {
            setTitle,
            getOneArticle,
            getOneCategory,
            match: {
                params: { categoryId, id },
            },
            setCurrentFormType,
            setCategoryId,
            cleanFroalaImages,
        } = this.props;
        setCategoryId(categoryId);
        const type = id ? currentFormTypes.EDIT : currentFormTypes.NEW;
        setCurrentFormType(type);
        cleanFroalaImages();
        setTitle("Knowledge Base \u203A Articles");
        getOneArticle({ id, categoryId });
        getOneCategory({ id: categoryId });
    }

    componentWillUnmount() {
        const { clearTitle, clearArticle, rollbackFroalaChanges } = this.props;
        clearTitle();
        clearArticle();
        rollbackFroalaChanges();
    }

    onSubmit = values => {
        const {
            match: {
                params: { categoryId },
            },
            putArticle,
        } = this.props;
        putArticle({
            categoryId,
            article: {
                ...values,
                content: values.type === "html" ? values.contentHtml : values.contentUrl,
            },
        });
    };

    render() {
        const {
            currentFormType,
            initialValues,
            history: { push },
            channelPostTypes,
            categoryId,
            category,
            errorRes: { error, errors },
        } = this.props;
        const { onSubmit } = this;

        return (
            <div>
                <MainTitle title={category.name} type="[Category]" />
                <div css={formsCss.genericError}>{error}</div>
                <Form
                    {...{
                        initialValues: {
                            ...initialValues,
                            contentHtml: initialValues.type === "html" ? initialValues.content : "",
                            contentUrl: initialValues.type === "url" ? initialValues.content : "",
                        },
                        onSubmit,
                        currentFormType,
                        push,
                        channelPostTypes,
                        categoryId,
                        category,
                        errors,
                    }}
                />
            </div>
        );
    }
}

const dispatchToProps = {
    setTitle: mainMenuActionCreators.setTitle.create,
    clearTitle: mainMenuActionCreators.clearTitle.create,
    getOneArticle: actionCreators.getOneArticle.create,
    setCurrentFormType: actionCreators.setCurrentFormType.create,
    putArticle: actionCreators.putArticle.create,
    setCategoryId: actionCreators.setCategoryId.create,
    getOneCategory: categoryActionCreators.getOneCategory.create,
    cleanFroalaImages: froalaActionCreators.cleanFroalaImages.create,
    rollbackFroalaChanges: froalaActionCreators.rollbackFroalaChanges.create,
    clearArticle: actionCreators.clearArticle.create,
};
const mapStateToProps = ({
    HowToArticle: { article, errorRes, currentFormType, categoryId },
    HowToCategory: { category },
}) => ({
    initialValues: article,
    errorRes,
    currentFormType,
    categoryId,
    category,
});

export default connect(mapStateToProps, dispatchToProps)(HowToArticlesEditContainer);
